var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-lg-12\" style=\"height: 30px !important;\">\n<div class=\"checkbox\">\n<label>\n<input type=\"checkbox\" class=\"formly-field-checkbox\" ng-model=\"model[options.key]\">\n{{to.label}}\n<span ng-if=\"options.data.modello.validations.nullable===false || options.data.modello.validations.required\">*</span>\n</label>\n</div>\n</div>\n";
var id1="bssbooleancheckbox.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;